import { gql } from '@apollo/client';

export default gql`
  fragment questionFeedbackFragment on QuestionFeedback {
    _id
  }
`;
